import React from 'react';
import { message } from 'antd';
import globalHook from 'use-global-hook';
import { fromJS } from 'immutable';
import { getPageInfo } from './webApi'

const initialState = {
  searchForm: fromJS({
    name: '',
    domainMac:'',
    type:null,
    warnType:null,
    pageNum:0,
    pageSize:10
  }),
  pageDataInfo:fromJS({
    pageDataList:null,
    total:null,
    size:null,
    number:null
  })
};
 
const actions = {
  setSearchForm: (store, value) => {
    const {searchForm} = store.state;
    store.setState({ searchForm: searchForm.set(value.get('key'),value.get('value'))});
  },
  resetSearchForm: (store) => {
    const {searchForm} = store.state;
    store.setState({ searchForm: searchForm.set('name','')
        .set('domainMac','')
        .set('type',null)
        .set('warnType',null)
        .set('pageNum',0)
        .set('pageSize',10)});
  },
  pageInfo:async (store,value)=>{
    const {searchForm} = store.state;
    let domainMac = searchForm.get('domainMac');
    let name = searchForm.get('name');
    let type = searchForm.get('type');
    let warnType = searchForm.get('warnType');
    let pageNum = searchForm.get('pageNum');
    let pageSize = searchForm.get('pageSize');
    if(value&&value.pageNum){
      pageNum = value.pageNum
    }
    if(value&&value.pageSize){
      pageSize = value.pageSize
    }
    const {code,context} = await getPageInfo({'pageNum':pageNum,'pageSize':pageSize,'companyName':name,'domainMac':domainMac,'type':type,'warnType':warnType});
    if(code==="K-000000"){
      const pageDataList = context.warnRecordVOPage.content;
      const total = context.warnRecordVOPage.total;
      const size = context.warnRecordVOPage.size;
      const number = context.warnRecordVOPage.number+1;
      const {pageDataInfo} = store.state;
      store.setState({pageDataInfo: pageDataInfo.set('pageDataList',pageDataList)
          .set('total',total)
          .set('size',size)
          .set('number',number)});
    } else {
      message.error('查询列表出错！');
    }
  }
};

export default globalHook(React, initialState, actions);